import * as tslib_1 from "tslib";
import { OnChanges, OnInit } from '@angular/core';
import { TravelArticlesService } from '../services/travel-articles.service';
var TravelArticlesComponent = /** @class */ (function () {
    function TravelArticlesComponent(_travelArticleService) {
        this._travelArticleService = _travelArticleService;
        this.isLoading = false;
    }
    TravelArticlesComponent.prototype.ngOnInit = function () {
        return tslib_1.__awaiter(this, void 0, void 0, function () {
            var _a;
            return tslib_1.__generator(this, function (_b) {
                switch (_b.label) {
                    case 0:
                        this.isLoading = true;
                        if (!(this.airportIdent != null)) return [3 /*break*/, 2];
                        _a = this;
                        return [4 /*yield*/, this._travelArticleService.getArticles(this.airportIdent.toLowerCase().trim())];
                    case 1:
                        _a.travelArticles = _b.sent();
                        _b.label = 2;
                    case 2:
                        this.isLoading = false;
                        return [2 /*return*/];
                }
            });
        });
    };
    TravelArticlesComponent.prototype.ngOnChanges = function () {
        return tslib_1.__awaiter(this, void 0, void 0, function () {
            var _a;
            return tslib_1.__generator(this, function (_b) {
                switch (_b.label) {
                    case 0:
                        this.isLoading = true;
                        if (!(this.airportIdent != null)) return [3 /*break*/, 2];
                        _a = this;
                        return [4 /*yield*/, this._travelArticleService.getArticles(this.airportIdent.toLowerCase().trim())];
                    case 1:
                        _a.travelArticles = _b.sent();
                        _b.label = 2;
                    case 2:
                        this.isLoading = false;
                        return [2 /*return*/];
                }
            });
        });
    };
    return TravelArticlesComponent;
}());
export { TravelArticlesComponent };
